module.exports = __webpack_public_path__ + "img/nature-19.ca935b3a.jpg";